import { Controller } from "@hotwired/stimulus"

// Affiche séquentiellement l'avertissement champignons (déresponsabilisation)
// puis le consentement cookies. Les acceptations sont mémorisées dans
// localStorage (clés versionnées : incrémenter la version pour re-solliciter).
export default class extends Controller {
  static targets = ["disclaimer", "cookies"]
  static values = {
    disclaimerKey: { type: String, default: "champi_disclaimer_v1" },
    cookiesKey: { type: String, default: "champi_cookies_v1" }
  }

  connect() {
    this.showNext()
  }

  showNext() {
    if (!this.stored(this.disclaimerKeyValue)) {
      this.open(this.disclaimerTarget)
    } else if (!this.stored(this.cookiesKeyValue)) {
      this.open(this.cookiesTarget)
    } else {
      this.element.remove()
    }
  }

  acceptDisclaimer() {
    this.store(this.disclaimerKeyValue)
    this.close(this.disclaimerTarget)
    this.showNext()
  }

  acceptCookies() {
    this.store(this.cookiesKeyValue, "accepted")
    this.close(this.cookiesTarget)
    this.showNext()
  }

  open(el) {
    el.classList.remove("hidden")
    el.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close(el) {
    el.classList.add("hidden")
    el.classList.remove("flex")
    document.body.style.overflow = ""
  }

  stored(key) {
    try { return !!window.localStorage.getItem(key) } catch (e) { return false }
  }

  store(key, val = "1") {
    try { window.localStorage.setItem(key, val) } catch (e) { /* mode privé : on n'insiste pas */ }
  }
}
